import request from "./request";

// banner
export function getBannerList(params) {
  return request({
    url: `web/sysBanner/front`,
    method: "get",
    params,
  });
}

// 案例查询
export function getCaseList(params) {
  return request({
    url: `web/sysNews/front`,
    method: "get",
    params,
  });
}

// 新闻查询
export function getNewsList(params) {
  return request({
    url: `web/sysNews/front`,
    method: "get",
    params,
  });
}

// 新闻详情
export function getNewInfo(id) {
  return request({
    url: `web/sysNews/front/${id}`,
    method: "get",
  });
}

// 增加留言
export function addFeedback(data) {
  return request({
    url: `web/sys-feedback/add`,
    method: "post",
    data,
  });
}

// 发展历程
export function getHistoryList(params) {
  return request({
    url: `web/sys-history/front/getHistoryList`,
    method: "get",
    params,
  });
}

// 查询资质 honorType:0-资质；1-荣誉
export function getCertification(params) {
  return request({
    url: `web/sys-honor/front`,
    method: "get",
    params,
  });
}

// 查询荣誉 honorType:0-资质；1-荣誉
export function getHonorList(params) {
  return request({
    url: `web/sys-honor/front/pageFrontHonor`,
    method: "get",
    params,
  });
}

// 查询团队风采
export function getTeamStyleList() {
  return request({
    url: `web/sysNews/front/listFrontNews`,
    method: "get",
    params: { newsCode: "1843997fae6f4800a0a362767cf18fe0" },
  });
}

// 查询资源文件
export function getFilesList(params) {
  return request({
    url: `web/file-database/front/pageFrontFileDatabaseList`,
    method: "get",
    params,
  });
}

// 查询资源文件详情
export function getFileInfo(params) {
  return request({
    url: `web/file-database/front/getDataBaseDetailById`,
    method: "get",
    params,
  });
}

// 查询招聘信息
export function getJobList(params) {
  return request({
    url: `web/sysJob/front/pageFrontJobList`,
    method: "get",
    params,
  });
}

// 查询企业简介图片
export function getIntroList() {
  return request({
    url: `web/sysNews/front/listFrontNews`,
    method: "get",
    params: { newsCode: "40f3ddbd20894eb8bead695048199b80" },
  });
}

// 查询全局配置
export function getConfig() {
  return request({
    url: `web/sys-web-config/front`,
    method: "get",
  });
}
